// extracted by mini-css-extract-plugin
export default {"root":"Jv4kCnF8","item":"_3S57wT4s","title":"_2O6b8k_P","titleIcon":"_1mg-6_Em","opened":"_1fV8BT_3","titleText":"_3Ohw2LKN","content":"uv7soMhw"};